import React from 'react';

import { useSelector } from 'react-redux';

import Headings from 'components/Headings';
import { defaultHomePageHeadingsConfig } from 'components/Headings/helpers';
import StoriesCarousel from 'components/StoriesCarousel';

import {
  RecommendedStoriesQueryVariables,
  StoryTileFragment,
  useRecommendedStoriesQuery,
} from 'graphql/generated/graphql';

import { IntlMsgShape } from 'helpers/consts';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

import ReduxState from 'store/ReduxState';
import './style.scss';

interface IProps {
  endpoint: string;
  queryVariables: Omit<RecommendedStoriesQueryVariables, 'campaign'>;
  recommendationComponentName: string;
  subtitle?: IntlMsgShape | string;
  title?: IntlMsgShape | string;
  matomoTrackingCategory: string;
}

const RecommendedStoriesCarousel = ({
  endpoint,
  queryVariables,
  recommendationComponentName,
  subtitle,
  title,
  matomoTrackingCategory,
}: IProps) => {
  const campaignArn = useSelector<ReduxState, string>(
    ({ recommendationsCampaigns }) =>
      recommendationsCampaigns[recommendationComponentName],
  );

  const { data, loading } = useRecommendedStoriesQuery({
    variables: {
      campaign: campaignArn,
      ...queryVariables,
    },
    ...useGraphaelDefaults(),
  });

  return (
    <div className="RecommendedStoriesCarousel">
      <Headings
        title={title}
        subtitle={subtitle}
        config={defaultHomePageHeadingsConfig}
      />

      <StoriesCarousel
        loading={loading}
        data={
          (data?.recommendedStories
            ?.recommendedStories as StoryTileFragment[]) || []
        }
        endpoint={endpoint}
        matomoTrackingCategory={matomoTrackingCategory}
      />
    </div>
  );
};

export default RecommendedStoriesCarousel;
